import React, { useState, useEffect, useCallback, useRef } from 'react'
import { DotButton, PrevButton, NextButton, SliceDotButton } from './emblaCarouselButtons'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

const EmblaCarousel = ({ arrows, children, dots = true, delayLength = 3000, loop, slidesToScroll, slice, autoplay = true }) => {
  const options = {
    loop: loop,
    slidesToScroll: slidesToScroll || 1,
    align: 'start',
    skipSnaps: false
  }
  const autoplayPlugin = useRef(Autoplay({ delay: delayLength, stopOnInteraction: false, stopOnMouseEnter: true }, (emblaRoot) => emblaRoot.parentElement))

  const plugins = autoplay ? [autoplayPlugin.current] : []
  const [emblaRef, emblaApi] = useEmblaCarousel(options, plugins)
  // const [emblaRef, emblaApi] = useEmblaCarousel(options, [autoplay.current])
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false)
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState([])

  const scrollNext = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollNext()
    autoplayPlugin.current.reset()
  }, [emblaApi, autoplayPlugin])

  const scrollPrev = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollPrev()
    autoplayPlugin.current.reset()
  }, [emblaApi, autoplayPlugin])

  const scrollTo = useCallback(
    (index) => {
      if (!emblaApi) return
      emblaApi.scrollTo(index)
    },
    [emblaApi]
  )

  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setSelectedIndex(emblaApi.selectedScrollSnap())
    setPrevBtnEnabled(emblaApi.canScrollPrev())
    setNextBtnEnabled(emblaApi.canScrollNext())
  }, [emblaApi, setSelectedIndex])

  useEffect(() => {
    if (!emblaApi) return
    onSelect()
    setScrollSnaps(emblaApi.scrollSnapList())
    emblaApi.on('select', onSelect)
  }, [emblaApi, onSelect, setScrollSnaps])

  return (
    <>
      <div className='embla relative w-full'>
        <div className='overflow-hidden' ref={emblaRef}>
          <div className='flex'>{children}</div>
        </div>
        {arrows && (
          <>
            <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
            <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
          </>
        )}
      </div>
      {slice && (
        <div className='embla__dots flex'>
          {slice.items.map((snap, index) => (
            <SliceDotButton selected={index === selectedIndex} onClick={() => scrollTo(index)} key={index} image={snap.image} label={snap.history_year} />
          ))}
        </div>
      )}
      {dots && (
        <div className='embla__dots'>
          {scrollSnaps.map((_, index) => (
            <DotButton key={index} selected={index === selectedIndex} onClick={() => scrollTo(index)} />
          ))}
        </div>
      )}
    </>
  )
}

export default EmblaCarousel
